import i18n from "lib/i18n"
import PropTypes from "prop-types"
import React, { useState } from "react"
import $ from "jquery"
import Flash from "lib/flash"
import { reloadWindowLocation } from "@theconversation/shared-libraries/windowLocation"

import Dialog from "../RemoveComment/Dialog"

/**
 * The remove all comments of a user component.
 * This component renders a link that'll trigger a dialog, where editors must choose the removal reason
 * for all user comments.
 *
 * You can opt out from showing the button and trigger the dialog manually by:
 * => passing `false` to the `showButton` prop
 * => controlling the dialog opened state through the `dialogOpen` prop
 *
 * @param {String} [buttonText] this will only appear when `showButton` is true
 * @param {String} [className] class attribute of the link to trigger the dialog
 * @param {Function} [closeDialogCallback] callback function when the dialog closes. Useful when you want to control state
 * @param {Boolean} [dialogOpen=false] determines if the dialog is opened
 * @param {String} removeCommentsPath path to submit the remove all comments POST action
 * @param {Boolean} [showButton=true] shows or hide action button
 * @param {String} userName the name to appear inside the dialog
 */

export default function RemoveAllComments({
  buttonText = "",
  className = "destroy danger button",
  closeDialogCallback = () => {},
  dialogOpen = false,
  removeCommentsPath,
  showButton = true,
  userName,
}) {
  const [internalModalOpen, setInternalModalOpen] = useState(false)
  const buttonCopy =
    buttonText ||
    i18n.t("editorial_comments.actions.remove_all_comments_by_user", { name: userName })

  const modalOpen = showButton ? internalModalOpen : dialogOpen

  const onSubmitDialog = ({ removalReason, notes }) => {
    $.ajax({
      url: removeCommentsPath,
      method: "POST",
      dataType: "json",
      data: {
        notes,
        reason: removalReason,
      },
      success: reloadWindowLocation,
      error: () => {
        Flash.now("alert", i18n.t("editorial_comments.error.message"))
      },
    })
  }

  return (
    <>
      {showButton ? (
        <button
          type="button"
          className={className}
          onClick={(event) => {
            event.preventDefault()
            setInternalModalOpen(true)
          }}
        >
          {buttonCopy}
        </button>
      ) : null}

      <Dialog
        closeModal={() => {
          closeDialogCallback()
          if (showButton) {
            setInternalModalOpen(false)
          }
        }}
        dialogTitle={i18n.t("editorial_comments.headers.remove_all_comments")}
        onSubmitDialog={onSubmitDialog}
        open={modalOpen}
        userName={userName}
      />
    </>
  )
}

RemoveAllComments.propTypes = {
  buttonText: PropTypes.string,
  className: PropTypes.string,
  closeDialogCallback: PropTypes.func,
  dialogOpen: PropTypes.bool,
  removeCommentsPath: PropTypes.string.isRequired,
  showButton: PropTypes.bool,
  userName: PropTypes.string.isRequired,
}
